export const searchYearsAreValid = ({
	yearFrom,
	yearTo,
	yearFromNumeric,
	yearToNumeric,
}) => {
	const stringsAreValid = [yearFrom, yearTo]
		.filter((year) => typeof year === 'string')
		.every((yearString) => yearString.match(/^-?\d+$/));

	const numbersAreValid = !(yearFromNumeric > yearToNumeric);

	return stringsAreValid && numbersAreValid;
};
